const routingRulesActionTypes = {
  SET_ROUTING_RULES: 'SET_ROUTING_RULES',
  ADD_ROUTING_RULE: 'ADD_ROUTING_RULE',
  UPDATE_ROUTING_RULE: 'UPDATE_ROUTING_RULE',
  REMOVE_ROUTING_RULE: 'REMOVE_ROUTING_RULE',
};
export default routingRulesActionTypes;
